// [EDITED: KPI Task - Mahesh Sharma]
import React, { useEffect, useState, useMemo } from "react"; // [EDITED: KPI Task - Mahesh Sharma]
import { employeeKpiAdminService, kpiService } from "../services/apiService"; // [EDITED: KPI Task - Mahesh Sharma]
import { useAuth } from "../context/AuthContext"; // [EDITED: KPI Task - Mahesh Sharma]
import Layout from "../components/Layout.jsx"; // [EDITED: KPI Task - Mahesh Sharma]
import { useNavigate } from "react-router-dom"; // [EDITED: KPI Task - Mahesh Sharma]
import { formatFYWeekLabel } from "../utils/fyWeekUtils"; // [EDITED: KPI Task - Mahesh Sharma]
import FYWeekPicker from "../components/FYWeekPicker"; // [EDITED: KPI Task - Mahesh Sharma]
import { exportKPIToExcel, exportKPIToPDF } from "../utils/kpiReportExport"; // [EDITED: KPI Task - Mahesh Sharma]
import { isKPILockedFrontend } from "../utils/kpiLockout"; // [EDITED: KPI Task - Mahesh Sharma]
import "./Kpi.css"; // [EDITED: KPI Task - Mahesh Sharma]

const getCurrentWeek = () => { // [EDITED: KPI Task - Mahesh Sharma]
  const now = new Date(); // [EDITED: KPI Task - Mahesh Sharma]
  const year = now.getFullYear(); // [EDITED: KPI Task - Mahesh Sharma]
  const firstJan = new Date(year, 0, 1); // [EDITED: KPI Task - Mahesh Sharma]
  const days = Math.floor((now - firstJan) / (24 * 60 * 60 * 1000)); // [EDITED: KPI Task - Mahesh Sharma]
  const week = Math.ceil((days + firstJan.getDay() + 1) / 7); // [EDITED: KPI Task - Mahesh Sharma]
  return `${year}-W${week.toString().padStart(2, "0")}`; // [EDITED: KPI Task - Mahesh Sharma]
}; // [EDITED: KPI Task - Mahesh Sharma]

const STATUS_ORDER = [ // [EDITED: KPI Task - Mahesh Sharma]
  "Draft",
  "TL Review Pending",
  "HOD Review Pending",
  "Admin Review Pending",
  "Completed"
];

const normalizeStatus = (status = "") => { // [EDITED: KPI Task - Mahesh Sharma]
  const s = status.toLowerCase();

  if (s.includes("draft")) return "Draft";
  if (s.includes("tl")) return "TL Review Pending";
  if (s.includes("hod")) return "HOD Review Pending";
  if (s.includes("admin")) return "Admin Review Pending";
  if (s.includes("complete") || s.includes("approved"))
    return "Completed";

  return "Draft";
};

const getConsolidatedStatus = (entries) => { // [EDITED: KPI Task - Mahesh Sharma]
  if (!entries || entries.length === 0) return "-";

  let lowestIndex = STATUS_ORDER.length - 1;

  entries.forEach(e => {
    const normalized = normalizeStatus(e.status);
    const index = STATUS_ORDER.indexOf(normalized);

    if (index !== -1 && index < lowestIndex) {
      lowestIndex = index;
    }
  });

  return STATUS_ORDER[lowestIndex];
};

const EmployeeKpiAdmin = () => { // [EDITED: KPI Task - Mahesh Sharma]
  const { user } = useAuth(); // [EDITED: KPI Task - Mahesh Sharma]
  const userRole = user?.role?.toLowerCase() || ""; // [EDITED: KPI Task - Mahesh Sharma]
  const navigate = useNavigate(); // [EDITED: KPI Task - Mahesh Sharma]

  const [selectedWeek, setSelectedWeek] = useState(getCurrentWeek()); // [EDITED: KPI Task - Mahesh Sharma]
  const [submissionTab, setSubmissionTab] = useState("all"); // "all" | "submitted" | "not_submitted" // [EDITED: KPI Task - Mahesh Sharma]
  const [kpis, setKpis] = useState([]); // [EDITED: KPI Task - Mahesh Sharma]
  const [notSubmittedList, setNotSubmittedList] = useState([]); // [EDITED: KPI Task - Mahesh Sharma]
  const [hierarchyData, setHierarchyData] = useState({ directReportees: [], subReportees: [], allHierarchy: [] }); // [EDITED: KPI Task - Mahesh Sharma]
  const [activeHierarchyView, setActiveHierarchyView] = useState("all"); // "all" | "direct" | "sub" // [EDITED: KPI Task - Mahesh Sharma]
  const [activeRatingTab, setActiveRatingTab] = useState("all"); // "all" | "not_rated" | "rated" // [EDITED: KPI Task - Mahesh Sharma]
  const [loading, setLoading] = useState(true); // [EDITED: KPI Task - Mahesh Sharma]
  const [error, setError] = useState(null); // [EDITED: KPI Task - Mahesh Sharma]
  const [searchFilter, setSearchFilter] = useState(""); // [EDITED: KPI Task - Mahesh Sharma]
  const [openDropdown, setOpenDropdown] = useState(null); // "hierarchy" | "status" | "rating" | null // [EDITED: KPI Task - Mahesh Sharma]

  // Global click handler to close dropdowns when clicking outside
  useEffect(() => { // [EDITED: KPI Task - Mahesh Sharma]
    const handleOutsideClick = (e) => { // [EDITED: KPI Task - Mahesh Sharma]
      if (!e.target.closest(".custom-filter-dropdown")) { // [EDITED: KPI Task - Mahesh Sharma]
        setOpenDropdown(null); // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]
    }; // [EDITED: KPI Task - Mahesh Sharma]
    document.addEventListener("click", handleOutsideClick); // [EDITED: KPI Task - Mahesh Sharma]
    return () => document.removeEventListener("click", handleOutsideClick); // [EDITED: KPI Task - Mahesh Sharma]
  }, []); // [EDITED: KPI Task - Mahesh Sharma]

  const isAdmin = userRole.includes("admin") || userRole === "administrator"; // [EDITED: KPI Task - Mahesh Sharma]
  const isLocked = !isAdmin && isKPILockedFrontend(new Date(), user?.role); // [EDITED: KPI Task - Mahesh Sharma]

  const loadKpiData = async (weekToFetch) => { // [EDITED: KPI Task - Mahesh Sharma]
    const targetWeek = weekToFetch || selectedWeek; // [EDITED: KPI Task - Mahesh Sharma]
    setLoading(true); // [EDITED: KPI Task - Mahesh Sharma]
    try { // [EDITED: KPI Task - Mahesh Sharma]
      let apiCall; // [EDITED: KPI Task - Mahesh Sharma]
      if (isAdmin) { // [EDITED: KPI Task - Mahesh Sharma]
        apiCall = employeeKpiAdminService.getPendingAdminKpis(); // [EDITED: KPI Task - Mahesh Sharma]
      } else if (userRole === "hod") { // [EDITED: KPI Task - Mahesh Sharma]
        apiCall = employeeKpiAdminService.getPendingHodKpis(); // [EDITED: KPI Task - Mahesh Sharma]
      } else { // [EDITED: KPI Task - Mahesh Sharma]
        apiCall = employeeKpiAdminService.getPendingTlKpis(); // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]

      const [pendingRes, hierarchyRes, submissionsStatusRes] = await Promise.allSettled([ // [EDITED: KPI Task - Mahesh Sharma]
        apiCall, // [EDITED: KPI Task - Mahesh Sharma]
        kpiService.getManagementHierarchy(""), // [EDITED: KPI Task - Mahesh Sharma]
        kpiService.getSubmissionsStatus(targetWeek) // [EDITED: KPI Task - Mahesh Sharma]
      ]); // [EDITED: KPI Task - Mahesh Sharma]

      if (pendingRes.status === "fulfilled") { // [EDITED: KPI Task - Mahesh Sharma]
        const data = pendingRes.value; // [EDITED: KPI Task - Mahesh Sharma]
        const safeData = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : []; // [EDITED: KPI Task - Mahesh Sharma]
        setKpis(safeData); // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]

      if (hierarchyRes.status === "fulfilled") { // [EDITED: KPI Task - Mahesh Sharma]
        const hData = hierarchyRes.value?.data?.data || hierarchyRes.value?.data || {}; // [EDITED: KPI Task - Mahesh Sharma]
        setHierarchyData({ // [EDITED: KPI Task - Mahesh Sharma]
          directReportees: Array.isArray(hData.directReportees) ? hData.directReportees : [], // [EDITED: KPI Task - Mahesh Sharma]
          subReportees: Array.isArray(hData.subReportees) ? hData.subReportees : [], // [EDITED: KPI Task - Mahesh Sharma]
          allHierarchy: Array.isArray(hData.allHierarchy) ? hData.allHierarchy : [] // [EDITED: KPI Task - Mahesh Sharma]
        }); // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]

      if (submissionsStatusRes.status === "fulfilled") { // [EDITED: KPI Task - Mahesh Sharma]
        const sData = submissionsStatusRes.value?.data || submissionsStatusRes.value || {}; // [EDITED: KPI Task - Mahesh Sharma]
        setNotSubmittedList(Array.isArray(sData.notSubmitted) ? sData.notSubmitted : []); // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]

      setError(null); // [EDITED: KPI Task - Mahesh Sharma]
    } catch (err) { // [EDITED: KPI Task - Mahesh Sharma]
      console.error("API Error:", err); // [EDITED: KPI Task - Mahesh Sharma]
      setError("Failed to fetch KPI data"); // [EDITED: KPI Task - Mahesh Sharma]
    } finally { // [EDITED: KPI Task - Mahesh Sharma]
      setLoading(false); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  useEffect(() => { // [EDITED: KPI Task - Mahesh Sharma]
    loadKpiData(selectedWeek); // [EDITED: KPI Task - Mahesh Sharma]
  }, [userRole, selectedWeek]); // [EDITED: KPI Task - Mahesh Sharma]

  const handleRevokeRating = async (kpiId) => { // [EDITED: KPI Task - Mahesh Sharma]
    if (!window.confirm("Are you sure you want to revoke this rating? The submission will be reopened for re-evaluation.")) { // [EDITED: KPI Task - Mahesh Sharma]
      return; // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
    try { // [EDITED: KPI Task - Mahesh Sharma]
      await kpiService.revokeKPIRating(kpiId); // [EDITED: KPI Task - Mahesh Sharma]
      alert("Rating revoked successfully! The KPI is now pending evaluation."); // [EDITED: KPI Task - Mahesh Sharma]
      loadKpiData(); // [EDITED: KPI Task - Mahesh Sharma]
    } catch (err) { // [EDITED: KPI Task - Mahesh Sharma]
      console.error("Revoke error:", err); // [EDITED: KPI Task - Mahesh Sharma]
      alert(err.response?.data?.message || "Failed to revoke rating"); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const convertDateToYearWeek = (dateString) => { // [EDITED: KPI Task - Mahesh Sharma]
    if (!dateString) return ""; // [EDITED: KPI Task - Mahesh Sharma]
    const date = new Date(dateString); // [EDITED: KPI Task - Mahesh Sharma]
    const year = date.getFullYear(); // [EDITED: KPI Task - Mahesh Sharma]
    const oneJan = new Date(year, 0, 1); // [EDITED: KPI Task - Mahesh Sharma]
    const week = Math.ceil(((date - oneJan) / 86400000 + oneJan.getDay() + 1) / 7); // [EDITED: KPI Task - Mahesh Sharma]
    return `${year}-W${week.toString().padStart(2, "0")}`; // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const allTransformedKpis = useMemo(() => { // [EDITED: KPI Task - Mahesh Sharma]
    const weekGroups = {}; // [EDITED: KPI Task - Mahesh Sharma]
    
    (kpis || []).forEach((kpi) => { // [EDITED: KPI Task - Mahesh Sharma]
      const week = kpi.week_number || convertDateToYearWeek(kpi.week_selected); // [EDITED: KPI Task - Mahesh Sharma]
      const employeeName = kpi.emp_name || kpi.employee_name || "Unknown"; // [EDITED: KPI Task - Mahesh Sharma]
      
      if (!weekGroups[week]) { // [EDITED: KPI Task - Mahesh Sharma]
        weekGroups[week] = {}; // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]
      
      if (!weekGroups[week][employeeName]) { // [EDITED: KPI Task - Mahesh Sharma]
        weekGroups[week][employeeName] = { // [EDITED: KPI Task - Mahesh Sharma]
          week, // [EDITED: KPI Task - Mahesh Sharma]
          employeeName, // [EDITED: KPI Task - Mahesh Sharma]
          kpis: [], // [EDITED: KPI Task - Mahesh Sharma]
          submissionDates: [], // [EDITED: KPI Task - Mahesh Sharma]
          targetDates: [], // [EDITED: KPI Task - Mahesh Sharma]
          statuses: [], // [EDITED: KPI Task - Mahesh Sharma]
        }; // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]
      
      weekGroups[week][employeeName].kpis.push(kpi); // [EDITED: KPI Task - Mahesh Sharma]
      if (kpi.submissionDate) { // [EDITED: KPI Task - Mahesh Sharma]
        weekGroups[week][employeeName].submissionDates.push(new Date(kpi.submissionDate)); // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]
      if (kpi.target_date || kpi.tat) { // [EDITED: KPI Task - Mahesh Sharma]
        weekGroups[week][employeeName].targetDates.push(new Date(kpi.target_date || kpi.tat)); // [EDITED: KPI Task - Mahesh Sharma]
      } // [EDITED: KPI Task - Mahesh Sharma]
      weekGroups[week][employeeName].statuses.push(kpi.status || "Pending"); // [EDITED: KPI Task - Mahesh Sharma]
    }); // [EDITED: KPI Task - Mahesh Sharma]

    const flattened = []; // [EDITED: KPI Task - Mahesh Sharma]
    Object.keys(weekGroups).forEach((week) => { // [EDITED: KPI Task - Mahesh Sharma]
      Object.keys(weekGroups[week]).forEach((employeeName) => { // [EDITED: KPI Task - Mahesh Sharma]
        const group = weekGroups[week][employeeName]; // [EDITED: KPI Task - Mahesh Sharma]
        const consolidatedStatus = getConsolidatedStatus(group.kpis); // [EDITED: KPI Task - Mahesh Sharma]
        const isRated = consolidatedStatus === "Completed" || // [EDITED: KPI Task - Mahesh Sharma]
          group.kpis.some(k => k.TLPoints !== null || k.hod_points !== null || k.mg_points !== null || (k.status || '').toLowerCase().includes('complete') || (k.status || '').toLowerCase().includes('approved')); // [EDITED: KPI Task - Mahesh Sharma]
        
        flattened.push({ // [EDITED: KPI Task - Mahesh Sharma]
          week: group.week, // [EDITED: KPI Task - Mahesh Sharma]
          employeeName: group.employeeName, // [EDITED: KPI Task - Mahesh Sharma]
          kpiId: group.kpis[0]?.id || group.kpis[0]?.kpi_id, // [EDITED: KPI Task - Mahesh Sharma]
          submissionDisplay: group.submissionDates.length > 0 ? new Date(Math.min(...group.submissionDates)).toLocaleDateString("en-GB") : "-", // [EDITED: KPI Task - Mahesh Sharma]
          targetDisplay: group.targetDates.length > 0 ? new Date(Math.min(...group.targetDates)).toLocaleDateString("en-GB") : "-", // [EDITED: KPI Task - Mahesh Sharma]
          statusDisplay: consolidatedStatus, // [EDITED: KPI Task - Mahesh Sharma]
          count: group.kpis.length, // [EDITED: KPI Task - Mahesh Sharma]
          rawKPIs: group.kpis, // [EDITED: KPI Task - Mahesh Sharma]
          isRated: isRated // [EDITED: KPI Task - Mahesh Sharma]
        }); // [EDITED: KPI Task - Mahesh Sharma]
      }); // [EDITED: KPI Task - Mahesh Sharma]
    }); // [EDITED: KPI Task - Mahesh Sharma]

    return flattened; // [EDITED: KPI Task - Mahesh Sharma]
  }, [kpis]); // [EDITED: KPI Task - Mahesh Sharma]

  const counts = useMemo(() => { // [EDITED: KPI Task - Mahesh Sharma]
    const directIds = new Set((hierarchyData.directReportees || []).map(e => Number(e.employee_id))); // [EDITED: KPI Task - Mahesh Sharma]
    const directNames = new Set((hierarchyData.directReportees || []).map(e => (e.employee_name || '').toLowerCase().trim())); // [EDITED: KPI Task - Mahesh Sharma]
    const subIds = new Set((hierarchyData.subReportees || []).map(e => Number(e.employee_id))); // [EDITED: KPI Task - Mahesh Sharma]
    const subNames = new Set((hierarchyData.subReportees || []).map(e => (e.employee_name || '').toLowerCase().trim())); // [EDITED: KPI Task - Mahesh Sharma]

    const directSubmitted = allTransformedKpis.filter(k => // [EDITED: KPI Task - Mahesh Sharma]
      k.rawKPIs?.some(raw => directIds.has(Number(raw.employee_id))) || directNames.has((k.employeeName || '').toLowerCase().trim()) // [EDITED: KPI Task - Mahesh Sharma]
    ).length; // [EDITED: KPI Task - Mahesh Sharma]

    const subSubmitted = allTransformedKpis.filter(k => // [EDITED: KPI Task - Mahesh Sharma]
      k.rawKPIs?.some(raw => subIds.has(Number(raw.employee_id))) || subNames.has((k.employeeName || '').toLowerCase().trim()) // [EDITED: KPI Task - Mahesh Sharma]
    ).length; // [EDITED: KPI Task - Mahesh Sharma]

    const allSubmitted = allTransformedKpis.length; // [EDITED: KPI Task - Mahesh Sharma]

    const directNotSubmitted = notSubmittedList.filter(emp => // [EDITED: KPI Task - Mahesh Sharma]
      directIds.has(Number(emp.employee_id)) || directNames.has((emp.employee_name || '').toLowerCase().trim()) // [EDITED: KPI Task - Mahesh Sharma]
    ).length; // [EDITED: KPI Task - Mahesh Sharma]

    const subNotSubmitted = notSubmittedList.filter(emp => // [EDITED: KPI Task - Mahesh Sharma]
      subIds.has(Number(emp.employee_id)) || subNames.has((emp.employee_name || '').toLowerCase().trim()) // [EDITED: KPI Task - Mahesh Sharma]
    ).length; // [EDITED: KPI Task - Mahesh Sharma]

    const allNotSubmitted = notSubmittedList.length; // [EDITED: KPI Task - Mahesh Sharma]

    return { // [EDITED: KPI Task - Mahesh Sharma]
      directSubmitted, // [EDITED: KPI Task - Mahesh Sharma]
      subSubmitted, // [EDITED: KPI Task - Mahesh Sharma]
      allSubmitted, // [EDITED: KPI Task - Mahesh Sharma]
      directNotSubmitted, // [EDITED: KPI Task - Mahesh Sharma]
      subNotSubmitted, // [EDITED: KPI Task - Mahesh Sharma]
      allNotSubmitted, // [EDITED: KPI Task - Mahesh Sharma]
    }; // [EDITED: KPI Task - Mahesh Sharma]
  }, [hierarchyData, allTransformedKpis, notSubmittedList]); // [EDITED: KPI Task - Mahesh Sharma]

  const transformedKpis = useMemo(() => { // [EDITED: KPI Task - Mahesh Sharma]
    const directEmpIds = new Set((hierarchyData.directReportees || []).map(e => Number(e.employee_id))); // [EDITED: KPI Task - Mahesh Sharma]
    const directNames = new Set((hierarchyData.directReportees || []).map(e => (e.employee_name || '').toLowerCase().trim())); // [EDITED: KPI Task - Mahesh Sharma]
    const subEmpIds = new Set((hierarchyData.subReportees || []).map(e => Number(e.employee_id))); // [EDITED: KPI Task - Mahesh Sharma]
    const subNames = new Set((hierarchyData.subReportees || []).map(e => (e.employee_name || '').toLowerCase().trim())); // [EDITED: KPI Task - Mahesh Sharma]

    let list = allTransformedKpis; // [EDITED: KPI Task - Mahesh Sharma]

    if (activeHierarchyView === 'direct') { // [EDITED: KPI Task - Mahesh Sharma]
      list = list.filter(k => // [EDITED: KPI Task - Mahesh Sharma]
        k.rawKPIs?.some(raw => directEmpIds.has(Number(raw.employee_id))) || directNames.has((k.employeeName || '').toLowerCase().trim()) // [EDITED: KPI Task - Mahesh Sharma]
      ); // [EDITED: KPI Task - Mahesh Sharma]
    } else if (activeHierarchyView === 'sub') { // [EDITED: KPI Task - Mahesh Sharma]
      list = list.filter(k => // [EDITED: KPI Task - Mahesh Sharma]
        k.rawKPIs?.some(raw => subEmpIds.has(Number(raw.employee_id))) || subNames.has((k.employeeName || '').toLowerCase().trim()) // [EDITED: KPI Task - Mahesh Sharma]
      ); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]

    return list.filter(r => { // [EDITED: KPI Task - Mahesh Sharma]
      const matchesSearch = !searchFilter.trim() || r.employeeName.toLowerCase().includes(searchFilter.toLowerCase()) || r.week.includes(searchFilter); // [EDITED: KPI Task - Mahesh Sharma]
      if (!matchesSearch) return false; // [EDITED: KPI Task - Mahesh Sharma]
      if (activeRatingTab === 'not_rated') return !r.isRated; // [EDITED: KPI Task - Mahesh Sharma]
      if (activeRatingTab === 'rated') return r.isRated; // [EDITED: KPI Task - Mahesh Sharma]
      return true; // [EDITED: KPI Task - Mahesh Sharma]
    }).sort((a, b) => { // [EDITED: KPI Task - Mahesh Sharma]
      if (a.week > b.week) return -1; // [EDITED: KPI Task - Mahesh Sharma]
      if (a.week < b.week) return 1; // [EDITED: KPI Task - Mahesh Sharma]
      return a.employeeName.localeCompare(b.employeeName); // [EDITED: KPI Task - Mahesh Sharma]
    }); // [EDITED: KPI Task - Mahesh Sharma]
  }, [allTransformedKpis, hierarchyData, activeHierarchyView, searchFilter, activeRatingTab]); // [EDITED: KPI Task - Mahesh Sharma]

  const filteredNotSubmitted = useMemo(() => { // [EDITED: KPI Task - Mahesh Sharma]
    if (!notSubmittedList || notSubmittedList.length === 0) return []; // [EDITED: KPI Task - Mahesh Sharma]
    
    let list = notSubmittedList; // [EDITED: KPI Task - Mahesh Sharma]
    if (activeHierarchyView === 'direct' && hierarchyData.directReportees?.length > 0) { // [EDITED: KPI Task - Mahesh Sharma]
      const directEmpIds = new Set(hierarchyData.directReportees.map(e => Number(e.employee_id))); // [EDITED: KPI Task - Mahesh Sharma]
      const directNames = new Set(hierarchyData.directReportees.map(e => (e.employee_name || '').toLowerCase().trim())); // [EDITED: KPI Task - Mahesh Sharma]
      list = list.filter(emp => directEmpIds.has(Number(emp.employee_id)) || directNames.has((emp.employee_name || '').toLowerCase().trim())); // [EDITED: KPI Task - Mahesh Sharma]
    } else if (activeHierarchyView === 'sub' && hierarchyData.subReportees?.length > 0) { // [EDITED: KPI Task - Mahesh Sharma]
      const subEmpIds = new Set(hierarchyData.subReportees.map(e => Number(e.employee_id))); // [EDITED: KPI Task - Mahesh Sharma]
      const subNames = new Set(hierarchyData.subReportees.map(e => (e.employee_name || '').toLowerCase().trim())); // [EDITED: KPI Task - Mahesh Sharma]
      list = list.filter(emp => subEmpIds.has(Number(emp.employee_id)) || subNames.has((emp.employee_name || '').toLowerCase().trim())); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]

    if (searchFilter.trim()) { // [EDITED: KPI Task - Mahesh Sharma]
      const q = searchFilter.toLowerCase(); // [EDITED: KPI Task - Mahesh Sharma]
      list = list.filter(emp =>  // [EDITED: KPI Task - Mahesh Sharma]
        (emp.employee_name || '').toLowerCase().includes(q) ||  // [EDITED: KPI Task - Mahesh Sharma]
        (emp.employee_code || '').toLowerCase().includes(q) ||  // [EDITED: KPI Task - Mahesh Sharma]
        (emp.department_name || '').toLowerCase().includes(q) // [EDITED: KPI Task - Mahesh Sharma]
      ); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]

    return list; // [EDITED: KPI Task - Mahesh Sharma]
  }, [notSubmittedList, hierarchyData, activeHierarchyView, searchFilter]); // [EDITED: KPI Task - Mahesh Sharma]

  const handleRowClick = (week, employeeName) => { // [EDITED: KPI Task - Mahesh Sharma]
    navigate(`/week-kpi-details/${week}?employee=${encodeURIComponent(employeeName)}`); // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const getStatusColor = (status) => { // [EDITED: KPI Task - Mahesh Sharma]
    const statusLower = status?.toLowerCase() || ""; // [EDITED: KPI Task - Mahesh Sharma]
    if (statusLower.includes("pending")) return "#ffc107"; // [EDITED: KPI Task - Mahesh Sharma]
    if (statusLower === "draft") return "#6c757d"; // [EDITED: KPI Task - Mahesh Sharma]
    if (statusLower === "completed" || statusLower === "approved") return "#198754"; // [EDITED: KPI Task - Mahesh Sharma]
    if (statusLower === "rejected") return "#dc3545"; // [EDITED: KPI Task - Mahesh Sharma]
    return "#6c757d"; // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const handleExportExcel = () => { // [EDITED: KPI Task - Mahesh Sharma]
    if (submissionTab === "submitted") { // [EDITED: KPI Task - Mahesh Sharma]
      exportKPIToExcel(transformedKpis, selectedWeek, "Management KPI Submissions Tracker"); // [EDITED: KPI Task - Mahesh Sharma]
    } else { // [EDITED: KPI Task - Mahesh Sharma]
      exportKPIToExcel(filteredNotSubmitted, selectedWeek, "KPI Not Submitted Employees Tracker"); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const handleExportPDF = () => { // [EDITED: KPI Task - Mahesh Sharma]
    if (submissionTab === "submitted") { // [EDITED: KPI Task - Mahesh Sharma]
      exportKPIToPDF(transformedKpis, selectedWeek, "Management KPI Submissions Tracker"); // [EDITED: KPI Task - Mahesh Sharma]
    } else { // [EDITED: KPI Task - Mahesh Sharma]
      exportKPIToPDF(filteredNotSubmitted, selectedWeek, "KPI Not Submitted Employees Tracker"); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  return ( // [EDITED: KPI Task - Mahesh Sharma]
    <Layout>
      <main className="main" style={{ padding: "1.5rem" }}>
        <div className="container-fluid">
          {/* Lockout alert */}
          {isLocked && (
            <div className="alert alert-warning d-flex align-items-center mb-3" role="alert">
              <i className="bi bi-lock-fill me-2 fs-5"></i>
              <div>
                <strong>KPI Submission & Rating Locked:</strong> Modifications for past cycles close every Monday at 10:00 AM.
              </div>
            </div>
          )}

          <div className="card shadow-sm border" style={{ borderRadius: "16px", borderColor: "#e2e8f0", background: "#ffffff", overflow: "visible" }}>
            {/* Green & White Theme Header */}
            <div 
              className="card-header py-3 px-4 d-flex justify-content-between align-items-center flex-wrap gap-3" 
              style={{ 
                background: "linear-gradient(135deg, #059669 0%, #10b981 100%)", 
                borderBottom: "1px solid #059669",
                color: "#ffffff",
                borderRadius: "16px 16px 0 0"
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <div style={{ background: "rgba(255,255,255,0.2)", borderRadius: "8px", padding: "6px 10px" }}>
                  <i className="bi bi-person-check-fill fs-5 text-white"></i>
                </div>
                <div>
                  <h5 className="mb-0 fw-bold text-white" style={{ letterSpacing: "-0.3px" }}>
                    {isAdmin ? "Admin KPI Management & Hierarchy" : userRole === "hod" ? "HOD KPI Review & Hierarchy" : "Team Lead KPI Review"}
                  </h5>
                  <span style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.85)" }}>
                    Weekly Performance & Evaluation Tracker
                  </span>
                </div>
              </div>

              <div className="d-flex align-items-center gap-2 flex-wrap">
                {/* Financial Year Week Picker */}
                <FYWeekPicker
                  value={selectedWeek}
                  onChange={(w) => setSelectedWeek(w)}
                  size="sm"
                  style={{ minWidth: "260px" }}
                />

                <button
                  type="button"
                  className="btn btn-sm btn-light text-success fw-bold d-flex align-items-center justify-content-center shadow-sm"
                  onClick={handleExportExcel}
                  disabled={loading || (submissionTab === "submitted" ? transformedKpis.length === 0 : filteredNotSubmitted.length === 0)}
                  style={{ borderRadius: "8px", border: "1px solid rgba(0,0,0,0.08)", width: "32px", padding: 0 }}
                  title="Download Excel Report"
                  aria-label="Download Excel Report"
                >
                  <i className="bi bi-file-earmark-excel-fill text-success"></i>
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger d-flex align-items-center justify-content-center shadow-sm"
                  onClick={handleExportPDF}
                  disabled={loading || (submissionTab === "submitted" ? transformedKpis.length === 0 : filteredNotSubmitted.length === 0)}
                  style={{ borderRadius: "8px", width: "32px", padding: 0 }}
                  title="Download PDF Report"
                  aria-label="Download PDF Report"
                >
                  <i className="bi bi-file-earmark-pdf-fill"></i>
                </button>
              </div>
            </div>

            {/* Modern Rounded Filter Box with Dropdowns & Chip System */}
            <div className="card-body border-bottom p-3" style={{ background: "#f8fafc", position: "relative", zIndex: 1050, overflow: "visible" }}>
              <div 
                className="p-3" 
                style={{ 
                  background: "#ffffff", 
                  borderRadius: "12px", 
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
                  position: "relative",
                  zIndex: 1050,
                  overflow: "visible"
                }}
              >
                {/* Top Row: Dropdown Selectors & Search Input */}
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    {/* Hierarchy Selector Dropdown */}
                    <div className="dropdown position-relative custom-filter-dropdown">
                      <button 
                        className="btn btn-sm btn-outline-secondary dropdown-toggle d-flex align-items-center gap-2"
                        type="button" 
                        onClick={() => setOpenDropdown(openDropdown === 'hierarchy' ? null : 'hierarchy')}
                        style={{ borderRadius: "8px", borderColor: "#cbd5e1", background: "#ffffff", color: "#1e293b", fontWeight: 500 }}
                      >
                        <i className="bi bi-diagram-3-fill text-success"></i>
                        <span>
                          Hierarchy: <strong>{activeHierarchyView === 'direct' ? 'Direct Reportees' : activeHierarchyView === 'sub' ? 'Multi-Level' : 'Full Team Tree'}</strong>
                        </span>
                      </button>
                      {openDropdown === 'hierarchy' && (
                        <div 
                          className="position-absolute shadow-lg border"
                          style={{
                            background: "#ffffff",
                            borderColor: "#cbd5e1",
                            borderRadius: "10px",
                            padding: "6px",
                            top: "calc(100% + 4px)",
                            left: 0,
                            zIndex: 9999,
                            minWidth: "240px"
                          }}
                        >
                          <button 
                            type="button"
                            className="w-100 text-start border-0 py-2 px-3 mb-1 d-flex align-items-center justify-content-between"
                            style={{
                              background: activeHierarchyView === 'all' ? '#059669' : 'transparent',
                              color: activeHierarchyView === 'all' ? '#ffffff' : '#1e293b',
                              borderRadius: '6px',
                              fontSize: '0.85rem',
                              fontWeight: activeHierarchyView === 'all' ? 600 : 500,
                              cursor: 'pointer',
                              transition: 'all 0.15s ease'
                            }}
                            onMouseEnter={(e) => {
                              if (activeHierarchyView !== 'all') {
                                e.currentTarget.style.background = '#f0fdf4';
                                e.currentTarget.style.color = '#047857';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (activeHierarchyView !== 'all') {
                                e.currentTarget.style.background = 'transparent';
                                e.currentTarget.style.color = '#1e293b';
                              }
                            }}
                            onClick={() => { setActiveHierarchyView('all'); setOpenDropdown(null); }}
                          >
                            <span>Full Team Tree</span>
                            <span className="badge ms-2" style={{ background: activeHierarchyView === 'all' ? 'rgba(255,255,255,0.25)' : '#e2e8f0', color: activeHierarchyView === 'all' ? '#fff' : '#475569' }}>
                              {submissionTab === 'not_submitted' ? counts.allNotSubmitted : counts.allSubmitted}
                            </span>
                          </button>

                          <button 
                            type="button"
                            className="w-100 text-start border-0 py-2 px-3 mb-1 d-flex align-items-center justify-content-between"
                            style={{
                              background: activeHierarchyView === 'direct' ? '#059669' : 'transparent',
                              color: activeHierarchyView === 'direct' ? '#ffffff' : '#1e293b',
                              borderRadius: '6px',
                              fontSize: '0.85rem',
                              fontWeight: activeHierarchyView === 'direct' ? 600 : 500,
                              cursor: 'pointer',
                              transition: 'all 0.15s ease'
                            }}
                            onMouseEnter={(e) => {
                              if (activeHierarchyView !== 'direct') {
                                e.currentTarget.style.background = '#f0fdf4';
                                e.currentTarget.style.color = '#047857';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (activeHierarchyView !== 'direct') {
                                e.currentTarget.style.background = 'transparent';
                                e.currentTarget.style.color = '#1e293b';
                              }
                            }}
                            onClick={() => { setActiveHierarchyView('direct'); setOpenDropdown(null); }}
                          >
                            <span>Direct Reportees</span>
                            <span className="badge ms-2" style={{ background: activeHierarchyView === 'direct' ? 'rgba(255,255,255,0.25)' : '#e2e8f0', color: activeHierarchyView === 'direct' ? '#fff' : '#475569' }}>
                              {submissionTab === 'not_submitted' ? counts.directNotSubmitted : counts.directSubmitted}
                            </span>
                          </button>

                          <button 
                            type="button"
                            className="w-100 text-start border-0 py-2 px-3 d-flex align-items-center justify-content-between"
                            style={{
                              background: activeHierarchyView === 'sub' ? '#059669' : 'transparent',
                              color: activeHierarchyView === 'sub' ? '#ffffff' : '#1e293b',
                              borderRadius: '6px',
                              fontSize: '0.85rem',
                              fontWeight: activeHierarchyView === 'sub' ? 600 : 500,
                              cursor: 'pointer',
                              transition: 'all 0.15s ease'
                            }}
                            onMouseEnter={(e) => {
                              if (activeHierarchyView !== 'sub') {
                                e.currentTarget.style.background = '#f0fdf4';
                                e.currentTarget.style.color = '#047857';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (activeHierarchyView !== 'sub') {
                                e.currentTarget.style.background = 'transparent';
                                e.currentTarget.style.color = '#1e293b';
                              }
                            }}
                            onClick={() => { setActiveHierarchyView('sub'); setOpenDropdown(null); }}
                          >
                            <span>Multi-Level Reportees</span>
                            <span className="badge ms-2" style={{ background: activeHierarchyView === 'sub' ? 'rgba(255,255,255,0.25)' : '#e2e8f0', color: activeHierarchyView === 'sub' ? '#fff' : '#475569' }}>
                              {submissionTab === 'not_submitted' ? counts.subNotSubmitted : counts.subSubmitted}
                            </span>
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Submission Status Dropdown */}
                    <div className="dropdown position-relative custom-filter-dropdown">
                      <button 
                        className="btn btn-sm btn-outline-secondary dropdown-toggle d-flex align-items-center gap-2"
                        type="button" 
                        onClick={() => setOpenDropdown(openDropdown === 'status' ? null : 'status')}
                        style={{ borderRadius: "8px", borderColor: "#cbd5e1", background: "#ffffff", color: "#1e293b", fontWeight: 500 }}
                      >
                        <i className="bi bi-folder2-open text-success"></i>
                        <span>
                          Status: <strong>{submissionTab === 'all' ? 'All Status' : submissionTab === 'submitted' ? 'Submitted' : 'Not Submitted'}</strong>
                        </span>
                      </button>
                      {openDropdown === 'status' && (
                        <div 
                          className="position-absolute shadow-lg border"
                          style={{
                            background: "#ffffff",
                            borderColor: "#cbd5e1",
                            borderRadius: "10px",
                            padding: "6px",
                            top: "calc(100% + 4px)",
                            left: 0,
                            zIndex: 9999,
                            minWidth: "240px"
                          }}
                        >
                          <button 
                            type="button"
                            className="w-100 text-start border-0 py-2 px-3 mb-1 d-flex align-items-center justify-content-between"
                            style={{
                              background: submissionTab === 'all' ? '#059669' : 'transparent',
                              color: submissionTab === 'all' ? '#ffffff' : '#1e293b',
                              borderRadius: '6px',
                              fontSize: '0.85rem',
                              fontWeight: submissionTab === 'all' ? 600 : 500,
                              cursor: 'pointer',
                              transition: 'all 0.15s ease'
                            }}
                            onMouseEnter={(e) => {
                              if (submissionTab !== 'all') {
                                e.currentTarget.style.background = '#f0fdf4';
                                e.currentTarget.style.color = '#047857';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (submissionTab !== 'all') {
                                e.currentTarget.style.background = 'transparent';
                                e.currentTarget.style.color = '#1e293b';
                              }
                            }}
                            onClick={() => { setSubmissionTab('all'); setOpenDropdown(null); }}
                          >
                            <span>All Status</span>
                            <span className="badge ms-2" style={{ background: submissionTab === 'all' ? 'rgba(255,255,255,0.25)' : '#e2e8f0', color: submissionTab === 'all' ? '#fff' : '#475569' }}>
                              All
                            </span>
                          </button>

                          <button 
                            type="button"
                            className="w-100 text-start border-0 py-2 px-3 mb-1 d-flex align-items-center justify-content-between"
                            style={{
                              background: submissionTab === 'submitted' ? '#059669' : 'transparent',
                              color: submissionTab === 'submitted' ? '#ffffff' : '#1e293b',
                              borderRadius: '6px',
                              fontSize: '0.85rem',
                              fontWeight: submissionTab === 'submitted' ? 600 : 500,
                              cursor: 'pointer',
                              transition: 'all 0.15s ease'
                            }}
                            onMouseEnter={(e) => {
                              if (submissionTab !== 'submitted') {
                                e.currentTarget.style.background = '#f0fdf4';
                                e.currentTarget.style.color = '#047857';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (submissionTab !== 'submitted') {
                                e.currentTarget.style.background = 'transparent';
                                e.currentTarget.style.color = '#1e293b';
                              }
                            }}
                            onClick={() => { setSubmissionTab('submitted'); setOpenDropdown(null); }}
                          >
                            <span>📥 Submitted</span>
                            <span className="badge ms-2" style={{ background: submissionTab === 'submitted' ? 'rgba(255,255,255,0.25)' : '#e2e8f0', color: submissionTab === 'submitted' ? '#fff' : '#475569' }}>
                              {activeHierarchyView === 'direct' ? counts.directSubmitted : activeHierarchyView === 'sub' ? counts.subSubmitted : counts.allSubmitted}
                            </span>
                          </button>

                          <button 
                            type="button"
                            className="w-100 text-start border-0 py-2 px-3 d-flex align-items-center justify-content-between"
                            style={{
                              background: submissionTab === 'not_submitted' ? '#059669' : 'transparent',
                              color: submissionTab === 'not_submitted' ? '#ffffff' : '#1e293b',
                              borderRadius: '6px',
                              fontSize: '0.85rem',
                              fontWeight: submissionTab === 'not_submitted' ? 600 : 500,
                              cursor: 'pointer',
                              transition: 'all 0.15s ease'
                            }}
                            onMouseEnter={(e) => {
                              if (submissionTab !== 'not_submitted') {
                                e.currentTarget.style.background = '#f0fdf4';
                                e.currentTarget.style.color = '#047857';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (submissionTab !== 'not_submitted') {
                                e.currentTarget.style.background = 'transparent';
                                e.currentTarget.style.color = '#1e293b';
                              }
                            }}
                            onClick={() => { setSubmissionTab('not_submitted'); setOpenDropdown(null); }}
                          >
                            <span>⏳ Not Submitted</span>
                            <span className="badge ms-2" style={{ background: submissionTab === 'not_submitted' ? 'rgba(255,255,255,0.25)' : '#e2e8f0', color: submissionTab === 'not_submitted' ? '#fff' : '#475569' }}>
                              {activeHierarchyView === 'direct' ? counts.directNotSubmitted : activeHierarchyView === 'sub' ? counts.subNotSubmitted : counts.allNotSubmitted}
                            </span>
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Rating Status Dropdown (when on Submitted or All) */}
                    {submissionTab !== 'not_submitted' && (
                      <div className="dropdown position-relative custom-filter-dropdown">
                        <button 
                          className="btn btn-sm btn-outline-secondary dropdown-toggle d-flex align-items-center gap-2"
                          type="button" 
                          onClick={() => setOpenDropdown(openDropdown === 'rating' ? null : 'rating')}
                          style={{ borderRadius: "8px", borderColor: "#cbd5e1", background: "#ffffff", color: "#1e293b", fontWeight: 500 }}
                        >
                          <i className="bi bi-star-fill text-warning"></i>
                          <span>
                            Rating: <strong>{activeRatingTab === 'all' ? 'All Ratings' : activeRatingTab === 'not_rated' ? 'Not Rated' : 'Rated'}</strong>
                          </span>
                        </button>
                        {openDropdown === 'rating' && (
                          <div 
                            className="position-absolute shadow-lg border"
                            style={{
                              background: "#ffffff",
                              borderColor: "#cbd5e1",
                              borderRadius: "10px",
                              padding: "6px",
                              top: "calc(100% + 4px)",
                              left: 0,
                              zIndex: 9999,
                              minWidth: "200px"
                            }}
                          >
                            <button 
                              type="button"
                              className="w-100 text-start border-0 py-2 px-3 mb-1 d-flex align-items-center justify-content-between"
                              style={{
                                background: activeRatingTab === 'all' ? '#059669' : 'transparent',
                                color: activeRatingTab === 'all' ? '#ffffff' : '#1e293b',
                                borderRadius: '6px',
                                fontSize: '0.85rem',
                                fontWeight: activeRatingTab === 'all' ? 600 : 500,
                                cursor: 'pointer',
                                transition: 'all 0.15s ease'
                              }}
                              onMouseEnter={(e) => {
                                if (activeRatingTab !== 'all') {
                                  e.currentTarget.style.background = '#f0fdf4';
                                  e.currentTarget.style.color = '#047857';
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (activeRatingTab !== 'all') {
                                  e.currentTarget.style.background = 'transparent';
                                  e.currentTarget.style.color = '#1e293b';
                                }
                              }}
                              onClick={() => { setActiveRatingTab('all'); setOpenDropdown(null); }}
                            >
                              <span>All Ratings</span>
                            </button>

                            <button 
                              type="button"
                              className="w-100 text-start border-0 py-2 px-3 mb-1 d-flex align-items-center justify-content-between"
                              style={{
                                background: activeRatingTab === 'not_rated' ? '#059669' : 'transparent',
                                color: activeRatingTab === 'not_rated' ? '#ffffff' : '#1e293b',
                                borderRadius: '6px',
                                fontSize: '0.85rem',
                                fontWeight: activeRatingTab === 'not_rated' ? 600 : 500,
                                cursor: 'pointer',
                                transition: 'all 0.15s ease'
                              }}
                              onMouseEnter={(e) => {
                                if (activeRatingTab !== 'not_rated') {
                                  e.currentTarget.style.background = '#f0fdf4';
                                  e.currentTarget.style.color = '#047857';
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (activeRatingTab !== 'not_rated') {
                                  e.currentTarget.style.background = 'transparent';
                                  e.currentTarget.style.color = '#1e293b';
                                }
                              }}
                              onClick={() => { setActiveRatingTab('not_rated'); setOpenDropdown(null); }}
                            >
                              <span>⏳ Not Rated</span>
                            </button>

                            <button 
                              type="button"
                              className="w-100 text-start border-0 py-2 px-3 d-flex align-items-center justify-content-between"
                              style={{
                                background: activeRatingTab === 'rated' ? '#059669' : 'transparent',
                                color: activeRatingTab === 'rated' ? '#ffffff' : '#1e293b',
                                borderRadius: '6px',
                                fontSize: '0.85rem',
                                fontWeight: activeRatingTab === 'rated' ? 600 : 500,
                                cursor: 'pointer',
                                transition: 'all 0.15s ease'
                              }}
                              onMouseEnter={(e) => {
                                if (activeRatingTab !== 'rated') {
                                  e.currentTarget.style.background = '#f0fdf4';
                                  e.currentTarget.style.color = '#047857';
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (activeRatingTab !== 'rated') {
                                  e.currentTarget.style.background = 'transparent';
                                  e.currentTarget.style.color = '#1e293b';
                                }
                              }}
                              onClick={() => { setActiveRatingTab('rated'); setOpenDropdown(null); }}
                            >
                              <span>✅ Rated</span>
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Search Input Box */}
                  <div className="position-relative" style={{ minWidth: "240px" }}>
                    <i 
                      className="bi bi-search position-absolute text-muted" 
                      style={{ left: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "0.8rem" }}
                    ></i>
                    <input
                      type="text"
                      placeholder="Filter employee or week..."
                      className="form-control form-control-sm ps-4"
                      style={{ borderRadius: "8px", borderColor: "#cbd5e1", fontSize: "0.85rem" }}
                      value={searchFilter}
                      onChange={(e) => setSearchFilter(e.target.value)}
                    />
                    {searchFilter && (
                      <button 
                        type="button" 
                        className="btn btn-sm btn-link text-muted position-absolute p-0"
                        style={{ right: "8px", top: "50%", transform: "translateY(-50%)", textDecoration: "none" }}
                        onClick={() => setSearchFilter("")}
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>

                {/* Bottom Row: Active Filter Chips with 'x' (Cross) button */}
                <div className="d-flex align-items-center gap-2 flex-wrap pt-2 border-top" style={{ borderColor: "#f1f5f9" }}>
                  <span className="text-muted small fw-semibold" style={{ fontSize: "0.78rem" }}>
                    <i className="bi bi-sliders me-1 text-success"></i> Active Filters:
                  </span>

                  {/* Hierarchy Chip (only when not 'all') */}
                  {activeHierarchyView !== 'all' && (
                    <div 
                      className="badge d-inline-flex align-items-center gap-1 py-1 px-2" 
                      style={{ 
                        background: "#ecfdf5", 
                        border: "1px solid #a7f3d0", 
                        color: "#065f46", 
                        borderRadius: "20px", 
                        fontSize: "0.78rem", 
                        fontWeight: 500 
                      }}
                    >
                      <span>
                        <i className="bi bi-diagram-3 me-1 text-success"></i>
                        Hierarchy: {activeHierarchyView === 'direct' ? 'Direct Reportees' : 'Multi-Level'}
                      </span>
                      <button 
                        type="button" 
                        className="btn btn-link p-0 text-success ms-1" 
                        style={{ textDecoration: 'none', lineHeight: 1, fontSize: '0.9rem' }}
                        onClick={() => setActiveHierarchyView('all')}
                        title="Remove hierarchy filter"
                      >
                        ✕
                      </button>
                    </div>
                  )}

                  {/* Submission Status Chip (only when not 'all') */}
                  {submissionTab !== 'all' && (
                    <div 
                      className="badge d-inline-flex align-items-center gap-1 py-1 px-2" 
                      style={{ 
                        background: submissionTab === 'not_submitted' ? "#fef2f2" : "#f0fdf4", 
                        border: submissionTab === 'not_submitted' ? "1px solid #fecaca" : "1px solid #bbf7d0", 
                        color: submissionTab === 'not_submitted' ? "#991b1b" : "#166534", 
                        borderRadius: "20px", 
                        fontSize: "0.78rem", 
                        fontWeight: 500 
                      }}
                    >
                      <span>
                        Status: {submissionTab === 'submitted' ? '📥 Submitted' : '⏳ Not Submitted'}
                      </span>
                      <button 
                        type="button" 
                        className="btn btn-link p-0 ms-1" 
                        style={{ 
                          textDecoration: 'none', 
                          lineHeight: 1, 
                          fontSize: '0.9rem', 
                          color: submissionTab === 'not_submitted' ? '#991b1b' : '#166534' 
                        }}
                        onClick={() => setSubmissionTab('all')}
                        title="Remove status filter"
                      >
                        ✕
                      </button>
                    </div>
                  )}

                  {/* Rating Status Chip (if not 'all' and not viewing 'not_submitted') */}
                  {submissionTab !== 'not_submitted' && activeRatingTab !== 'all' && (
                    <div 
                      className="badge d-inline-flex align-items-center gap-1 py-1 px-2" 
                      style={{ 
                        background: activeRatingTab === 'rated' ? "#f0fdf4" : "#fffbeb", 
                        border: activeRatingTab === 'rated' ? "1px solid #bbf7d0" : "1px solid #fde68a", 
                        color: activeRatingTab === 'rated' ? "#166534" : "#92400e", 
                        borderRadius: "20px", 
                        fontSize: "0.78rem", 
                        fontWeight: 500 
                      }}
                    >
                      <span>
                        Rating: {activeRatingTab === 'rated' ? '✅ Rated' : '⏳ Not Rated'}
                      </span>
                      <button 
                        type="button" 
                        className="btn btn-link p-0 ms-1" 
                        style={{ 
                          textDecoration: 'none', 
                          lineHeight: 1, 
                          fontSize: '0.9rem', 
                          color: activeRatingTab === 'rated' ? '#166534' : '#92400e' 
                        }}
                        onClick={() => setActiveRatingTab('all')}
                        title="Remove rating filter"
                      >
                        ✕
                      </button>
                    </div>
                  )}

                  {/* Search Filter Chip (if active) */}
                  {searchFilter.trim() && (
                    <div 
                      className="badge d-inline-flex align-items-center gap-1 py-1 px-2" 
                      style={{ 
                        background: "#f1f5f9", 
                        border: "1px solid #cbd5e1", 
                        color: "#334155", 
                        borderRadius: "20px", 
                        fontSize: "0.78rem", 
                        fontWeight: 500 
                      }}
                    >
                      <span>🔍 "{searchFilter}"</span>
                      <button 
                        type="button" 
                        className="btn btn-link p-0 text-secondary ms-1" 
                        style={{ textDecoration: 'none', lineHeight: 1, fontSize: '0.9rem' }}
                        onClick={() => setSearchFilter("")}
                        title="Clear search"
                      >
                        ✕
                      </button>
                    </div>
                  )}

                  {/* If no filters active */}
                  {activeHierarchyView === 'all' && submissionTab === 'all' && activeRatingTab === 'all' && !searchFilter.trim() && (
                    <span className="text-muted small fst-italic" style={{ fontSize: "0.78rem" }}>
                      Showing all records (No filters applied)
                    </span>
                  )}

                  {/* Clear All Filters button */}
                  {(activeHierarchyView !== 'all' || submissionTab !== 'all' || activeRatingTab !== 'all' || searchFilter.trim()) && (
                    <button 
                      type="button"
                      className="btn btn-link p-0 text-muted small ms-auto"
                      style={{ fontSize: "0.78rem", textDecoration: "none", color: "#64748b" }}
                      onClick={() => {
                        setActiveHierarchyView('all');
                        setSubmissionTab('all');
                        setActiveRatingTab('all');
                        setSearchFilter('');
                      }}
                    >
                      <i className="bi bi-arrow-counterclockwise me-1"></i> Clear All Filters
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="card-body p-0" style={{ position: "relative", zIndex: 1 }}>
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : error ? (
                <div className="alert alert-danger m-3">{error}</div>
              ) : submissionTab === "not_submitted" ? (
                /* Not Submitted Table */
                <div className="table-responsive" style={{ maxHeight: "calc(100vh - 280px)", overflowY: "auto", minHeight: "350px" }}>
                  <table className="table table-hover align-middle mb-0" style={{ fontSize: "0.875rem" }}>
                    <thead style={{ background: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                      <tr className="text-secondary" style={{ fontSize: "0.8rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        <th className="ps-3 py-3">#</th>
                        <th className="py-3">Employee Code</th>
                        <th className="py-3">Employee Name</th>
                        <th className="py-3">Department</th>
                        <th className="py-3">Role / Designation</th>
                        <th className="py-3">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredNotSubmitted.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center text-success py-5">
                            <i className="bi bi-check-circle fs-3 d-block mb-2 text-success"></i>
                            All employees in this category have submitted their KPIs for this week!
                          </td>
                        </tr>
                      ) : (
                        filteredNotSubmitted.map((emp, idx) => (
                          <tr key={emp.employee_id || idx} style={{ transition: "background-color 0.15s ease" }}>
                            <td className="ps-3 fw-medium text-muted">{idx + 1}</td>
                            <td className="fw-semibold text-secondary">{emp.employee_code || "-"}</td>
                            <td className="fw-semibold" style={{ color: "#047857" }}>{emp.employee_name || `${emp.first_name || ""} ${emp.last_name || ""}`.trim()}</td>
                            <td>{emp.department_name || "-"}</td>
                            <td>{emp.role || emp.designation || "-"}</td>
                            <td>
                              <span className="badge bg-danger text-white px-2 py-1" style={{ borderRadius: "6px", fontSize: "0.75rem" }}>
                                <i className="bi bi-x-circle me-1"></i> Not Submitted
                              </span>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                /* Submitted KPI Table */
                <div className="table-responsive" style={{ maxHeight: "calc(100vh - 280px)", overflowY: "auto", minHeight: "350px" }}>
                  <table className="table table-hover align-middle mb-0" style={{ fontSize: "0.875rem" }}>
                    <thead style={{ background: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                      <tr className="text-secondary" style={{ fontSize: "0.8rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        <th className="ps-3 py-3">Week</th>
                        <th className="py-3">Employee Name</th>
                        <th className="py-3">Submission Date</th>
                        <th className="py-3">Target Date</th>
                        <th className="py-3">Workflow Status</th>
                        <th className="py-3">Entries</th>
                        <th className="text-center py-3">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transformedKpis.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center text-muted py-5">
                            No KPI records found
                          </td>
                        </tr>
                      ) : (
                        transformedKpis.map((row, index) => (
                          <tr
                            key={`${row.week}-${row.employeeName}-${index}`}
                            onClick={() => handleRowClick(row.week, row.employeeName)}
                            style={{ cursor: "pointer", transition: "background-color 0.15s ease" }}
                          >
                            <td className="ps-3 fw-medium">
                              <span className="fw-bold" style={{ color: "#0f172a" }}>{row.week}</span>
                              <br />
                              <span className="text-muted small" style={{ fontSize: "0.75rem" }}>
                                {formatFYWeekLabel(row.week)}
                              </span>
                            </td>
                            <td className="fw-semibold" style={{ color: "#047857" }}>{row.employeeName}</td>
                            <td>{row.submissionDisplay}</td>
                            <td>{row.targetDisplay}</td>
                            <td>
                              <div className="d-flex align-items-center">
                                <span
                                  style={{
                                    display: "inline-block",
                                    width: "9px",
                                    height: "9px",
                                    borderRadius: "50%",
                                    backgroundColor: getStatusColor(row.statusDisplay),
                                    marginRight: "8px"
                                  }}
                                ></span>
                                <span>{row.statusDisplay}</span>
                                {row.isRated ? ( // [EDITED: KPI Task - Mahesh Sharma]
                                  <span className="badge bg-success ms-2" style={{ fontSize: '0.65rem', borderRadius: '4px' }}>Rated</span> // [EDITED: KPI Task - Mahesh Sharma]
                                ) : ( // [EDITED: KPI Task - Mahesh Sharma]
                                  <span className="badge bg-warning text-dark ms-2" style={{ fontSize: '0.65rem', borderRadius: '4px' }}>Not Rated</span> // [EDITED: KPI Task - Mahesh Sharma]
                                )}
                              </div>
                            </td>
                            <td>
                              <span className="badge bg-secondary px-2 py-1">
                                {row.count}
                              </span>
                            </td>
                            <td className="text-center" onClick={(e) => e.stopPropagation()}>
                              {row.kpiId && (
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm"
                                  onClick={() => handleRevokeRating(row.kpiId)}
                                  style={{ fontSize: "0.75rem", padding: "0.2rem 0.5rem" }}
                                  title="Revoke and reopen KPI rating"
                                >
                                  <i className="bi bi-arrow-counterclockwise me-1"></i> Revoke
                                </button>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default EmployeeKpiAdmin; // [EDITED: KPI Task - Mahesh Sharma]